import React, { useEffect, useMemo, useRef, useState } from 'react';
import KkpColorBadge from '../kkp/KkpColorBadge';
import CommercialSelect from '../CommercialSelect';
import hebergementService from '../../services/hebergementService';

const SiteCommercialInlineCell = ({
  siteInfo,
  commerciaux,
  apiWorking,
  onUpdated,
}) => {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const rootRef = useRef(null);

  const options = useMemo(
    () => (commerciaux ?? []).map((c) => ({ value: String(c.id), label: c.nom })),
    [commerciaux],
  );

  useEffect(() => {
    if (!editing) return undefined;

    const handleClickOutside = (event) => {
      if (rootRef.current?.contains(event.target)) return;
      // Laisser le menu portal du SearchableSelect gérer sa fermeture ;
      // on ne quitte l’édition que hors du trigger.
      if (event.target?.closest?.('.searchable-select__menu')) return;
      setEditing(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [editing]);

  const saveCommercial = async (value) => {
    if (!apiWorking || saving) return;

    const nextId = value ? Number(value) : null;
    if (nextId === (siteInfo.commercialId ?? null)) {
      setEditing(false);
      return;
    }

    setSaving(true);
    try {
      const response = await hebergementService.linkCommercial(siteInfo.id, nextId);
      if (response.success && response.data) {
        onUpdated?.(siteInfo.id, response.data);
      }
    } catch (err) {
      console.error('Erreur liaison commercial:', err);
    } finally {
      setSaving(false);
      setEditing(false);
    }
  };

  const handleDoubleClick = () => {
    if (!apiWorking || saving) return;
    setEditing(true);
  };

  if (editing) {
    return (
      <div ref={rootRef} style={{ minWidth: '180px' }}>
        <CommercialSelect
          value={siteInfo.commercialId ?? ''}
          onChange={(next) => saveCommercial(next)}
          options={options}
          disabled={saving}
          buttonClassName="form-select form-select-sm text-start"
        />
      </div>
    );
  }

  return (
    <div
      role="button"
      tabIndex={0}
      onDoubleClick={handleDoubleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') handleDoubleClick();
      }}
      title={apiWorking ? 'Double-cliquer pour modifier' : undefined}
      style={{ cursor: apiWorking ? 'pointer' : 'default' }}
    >
      {saving ? (
        <span className="text-muted small">Enregistrement…</span>
      ) : siteInfo.commercialNom ? (
        <KkpColorBadge color={siteInfo.commercialCouleur} vivid>
          {siteInfo.commercialNom}
        </KkpColorBadge>
      ) : (
        <span className="text-muted">—</span>
      )}
    </div>
  );
};

export default SiteCommercialInlineCell;
